import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { formatInvoiceCurrencyAmount, paymentCurrency } from 'helpers/invoiceCurrency';

export default function InvoiceDepositPayments({ payments, currency }) {
  return <>{(Array.isArray(payments) ? payments : []).filter(payment =>
    (payment.type === 'Deposit' || (payment.type === 'Voucher' && [true, 1, '1'].includes(payment.is_deposit)))
    && ['paid', 'succeeded', 'completed'].includes(String(payment.status).toLowerCase())
    && Number(payment.amount?.amount_minor ?? Number(payment.amount) * 100) > 0,
  ).map((payment, index) => <li className="py-3" key={payment.id ?? index}>
    <div className="row gx-1 justify-content-between">
      <h6 className="mb-0 col-10">Deposit Paid by {payment.paidby || payment.paid_by || 'Payment'}{payment.created_at || payment.payment_date ? ` ${moment(payment.created_at || payment.payment_date).format('DD/MM/YYYY')}` : ''}</h6>
      <h6 className="mb-0 col-2 text-end">{formatInvoiceCurrencyAmount(payment.amount, paymentCurrency(payment, currency))}</h6>
    </div>
  </li>)}</>;
}

InvoiceDepositPayments.propTypes = { payments: PropTypes.arrayOf(PropTypes.object), currency: PropTypes.string };
